/**
 * Lucide icon resolution helper. Maps `LucideIconName` (kebab-case
 * literal from `@src/types/speedtest.ts`) to the Vue Component that
 * paints it. `MetricDef.icon` is the single source of truth.
 *
 * Per-icon deep-imports keep Rollup from pulling the @lucide/vue
 * barrel into the entry chunk.
 *
 * Adding a metric icon: extend `LucideIconName` at `speedtest.ts` AND
 * add to `ICONS` below in the same edit — TypeScript's exhaustiveness
 * check on `Record<LucideIconName, Component>` will surface drift at
 * compile time.
 */
import ArrowDown from "@lucide/vue/dist/esm/icons/arrow-down.mjs";
import ArrowUp from "@lucide/vue/dist/esm/icons/arrow-up.mjs";
import Activity from "@lucide/vue/dist/esm/icons/activity.mjs";
import Wifi from "@lucide/vue/dist/esm/icons/wifi.mjs";
import type { Component } from "vue";
import type { LucideIconName } from "@src/types/speedtest.ts";

const ICONS: Record<LucideIconName, Component> = {
    "arrow-down": ArrowDown,
    "arrow-up": ArrowUp,
    "activity": Activity,
    "wifi": Wifi,
};

/** Resolve a kebab-case lucide icon name to its Vue Component.
 *  The argument is type-constrained to `LucideIconName`, so misspellings
 *  fail at compile time rather than runtime. */
export function getLucideIcon(name: LucideIconName): Component {
    return ICONS[name];
}
